/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

export const FaqEl = styled.div`
  padding: 2em 1em;

  > h4 {
    font-weight: bold;
    margin: 2.5em 0;
  }
`
